import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { defineMessages, useIntl } from 'react-intl';

import { ErrorBoundaryFallback } from '@components/ErrorBoundaryFallback';
import { RoleGuard } from '@components/Guards';

import { RoleName } from '@constants/role_name';

import { useSession } from '@hooks/useSession';

import { formatName } from '@utils/format';

import { PatientDiscernUpload } from '@views/Discern';
import MainWrapper from '@views/Records/Common/MainWrapper';

const messages = defineMessages({
  title: {
    id: 'patientDiscern.title',
    defaultMessage: 'Patient Curation Processing',
  },
});

export default function DiscernJobsPage() {
  const { formatMessage } = useIntl();

  const {
    state: { activeProfile },
  } = useSession();
  const patientName =
    formatName(activeProfile?.first_name, activeProfile?.last_name) ?? '';
  return (
    <RoleGuard roles={[RoleName.Curator, RoleName.CuratorAdmin]}>
      <MainWrapper
        backgroundIcon="discern"
        friendlyName={patientName}
        title={formatMessage(messages.title)}
      >
        <ErrorBoundary FallbackComponent={ErrorBoundaryFallback}>
          <PatientDiscernUpload
            vitallPatientId={
              activeProfile?.vitall_patient?.vitall_patient_id ?? ''
            }
            patientName={patientName}
          />
        </ErrorBoundary>
      </MainWrapper>
    </RoleGuard>
  );
}
